import { Link, Navigate, Route, Routes } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Typography } from '@mui/material';
import Component from '../../components/Component';
import PromoSurfaceEditor from './PromoSurfaceEditor';
import PromoSurfaceHub from './PromoSurfaceHub';
import PromoSurfaceList from './PromoSurfaceList';

function PromoSurfaces() {
  return (
    <Component>
      <div
        style={{
          marginLeft: '280px',
          marginTop: '80px',
          padding: '20px',
          width: 'calc(100% - 280px)',
        }}
      >
        <div className="d-flex align-items-center mb-2">
          <IconButton style={{ background: '#FFFFFF' }} component={Link} to="/">
            <ArrowBackIcon />
          </IconButton>
          <div style={{ marginLeft: '12px' }}>
            <h2 style={{ margin: 0 }}>Promo surfaces</h2>
            <Typography variant="body2" color="text.secondary">
              Homepage chrome for the corner ribbon, the corner video, and the bottom tab bar.
            </Typography>
          </div>
        </div>
        <Routes>
          <Route index element={<PromoSurfaceHub />} />
          <Route path=":surfaceKey/new" element={<PromoSurfaceEditor />} />
          <Route path=":surfaceKey/:id" element={<PromoSurfaceEditor />} />
          <Route path=":surfaceKey" element={<PromoSurfaceList />} />
          <Route path="*" element={<Navigate to="/admin/promo" replace />} />
        </Routes>
      </div>
    </Component>
  );
}

export default PromoSurfaces;
